import { useEffect, useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const scrollPositions = new Map<string, number>()

export function useRouteScrollRestore() {
  const { pathname } = useLocation()
  const prevPathname = useRef(pathname)

  useEffect(() => {
    function onScroll() {
      scrollPositions.set(prevPathname.current, window.scrollY)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useLayoutEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname
      window.scrollTo(0, scrollPositions.get(pathname) ?? 0)
    }
  }, [pathname])
}

// Scrolls the window back to the top and forgets the saved position for the
// current route, so leaving and returning doesn't drop the user back where they
// were before the tap.
export function scrollToTop(pathname: string) {
  scrollPositions.set(pathname, 0)
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
}
